'use client';

import { login } from '~/api/appDir/actions/login';
import BaseAuthIFrame from '~/components/LoginRegister/AuthIFrame/BaseAuthIFrame';
import useKnownCookie from '~/hooks/useKnownCookie';
import { dispatchLoginEvent } from '~/lib/events/customEvents';

export default function AppDirAuthIFrame({
  initialView,
  onSuccessfulLogin,
  skipJoinOnboarding,
}: {
  initialView?: 'login' | 'register';
  onSuccessfulLogin: () => void;
  skipJoinOnboarding?: boolean;
}) {
  const [clientId] = useKnownCookie('sls_client_id');
  if (!clientId) {
    return null;
  }

  return (
    <BaseAuthIFrame
      clientId={clientId!}
      handleLogin={async event => {
        await login(event);
        dispatchLoginEvent();
      }}
      onSuccessfulLogin={onSuccessfulLogin}
      skipJoinOnboarding={skipJoinOnboarding}
      defaultView={initialView}
    />
  );
}
